import {UrlBuilder} from '../../../lib/utility/UrlBuilder';

export const MARKUP_QUALITY = 70;

export const createUrlBuilder = (viewport, imageId) => {
  let root = viewport.getFullURL();
  if (!root) {
    root = `${viewport.getServer()}${viewport.getImageId()}}`;
  }
  const builder = new UrlBuilder(root, viewport.getImageId(), MARKUP_QUALITY);
  builder.setImageId(imageId);
  return builder;
};

export const isVisible = (region, viewport) => {
  return region.markupIsInView(viewport.getVPViewRect2());
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/image-analysis/markup/markup-utils.js